import styles from "../../styles/pages/herkunft/index.module.css"
import Collapsible from "../../components/collapsible/collapsible";
import Layout from "../../components/shared/layout/layout";
import Link from "next/link";
import Seo from "../../components/shared/seo/seo";


export default function herkunft(){
    return (
        <Layout>
            <Seo title="Herkunft" description="Die Herkunft unserer Weine: Thermenregion, Gebiet, Ortschaften und Tourismus." path="/herkunft" />
            <section className="background_light_texture no_fill">
                <div className="col-8">
                    <h1 className="white">Herkunft</h1>
                    <p className="robertson brown subtitle">mit System</p>
                    <p>Wie das Haus, in dem man aufwächst, die Sonnenstrahlen, die bei der Weingartenarbeit auf die Haut wirken, der langersehnte Regen ein Aufatmen bringt und der immerwährende Wechsel der Vegetation zwischen den Jahreszeiten das Leben eines Winzers prägt, so ist authentischer Wein ein Abbild seiner Herkunft auf dem der Rebstock wurzelt.<br/><br/>

                        Schon die Römer & Griechen erkannten die große Bedeutung der Herkunft ihrer Weine, weshalb sie diese auch auf den Amphoren festhielten. Mit unserer Herkunftspyramide folgen wir einer jahrhundertealten Tradition, die durch Klarheit und Transparenz Unverwechselbarkeit schafft. </p>
                </div>
                <div className="col-8">
                <div className="horizontal">
                    <div className="col-3 right">
                        <Link href="#klassifikation"><p className="white annotation marker link">Klassifikation</p></Link>
                    </div>
                    <div className="col-3 left">
                        <Link href="#rieden"><p className="white annotation marker link">Rieden</p></Link>
                    </div>
                </div>
                <div className="horizontal" style={{marginTop:"-20px"}}>
                    <div className="col-3">
                        <Link href="#ortschaften"><p className="white annotation marker link">Ortschaften</p></Link>
                    </div>
                    <div className="col-3">
                        <Link href="#gebiet"><p className="white annotation marker link">Gebiet</p></Link>
                    </div>
                    <div className="col-3">
                        <Link href="#tourismus"><p className="white annotation marker link">Tourismus</p></Link>
                    </div>
                </div>
                </div>
            </section>
            <section className="background_light ">
                <span  className="anchor" id="klassifikation" ></span>
                <div className="col-12">
                    <h2>Klassifikation</h2>
                </div>
                <div className="horizontal">
                    <div className="col-6 start">
                        <svg className={styles.class_svg} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 705.462 469.475">
                            <g id="Group_1294" data-name="Group 1294" transform="translate(-271.131 -1475.853)">
                                <path id="pattern" d="M336.15,0,258.74,103.029H413.56Z" transform="translate(287.785 1476.686)" fill="none" stroke="#7c6765" strokeWidth="1"/>
                                <path id="pattern-2" data-name="pattern" d="M454.01,79.83H271.8L194.055,183.307h337.7Z" transform="translate(261.656 1518.113)" fill="none" stroke="#7c6765" strokeWidth="1"/>
                                <path id="pattern-3" data-name="pattern" d="M207.16,159.953,129.369,263.49H650.251L572.46,159.953Z" transform="translate(234.555 1559.441)" fill="none"/>
                                <path id="pattern-4" data-name="pattern" d="M572.205,159.953H207.116L129.37,263.43H649.951Z" transform="translate(234.555 1559.694)" fill="none" stroke="#7c6765" strokeWidth="1"/>
                                <path id="pattern-5" data-name="pattern" d="M690.4,240.077H142.43L64.685,343.553h703.46Z" transform="translate(207.447 1601.275)" fill="none" stroke="#7c6765" strokeWidth="1"/>
                                <g id="component_leicht_fruchtig" onMouseOut={() => hideDiv("content_leichtfruchtig")} onMouseOver={() => showDiv("content_leichtfruchtig")} data-name="Component 30 – 1" transform="translate(294.381 1868)">
                                    <g id="Rectangle_134" data-name="Rectangle 134" fill="#f2efed" stroke="#766260" strokeWidth="1">
                                        <rect width="309" height="49" stroke="none"/>
                                        <rect x="0.5" y="0.5" width="308" height="48" fill="none"/>
                                    </g>
                                    <text id="leicht_fruchtig" data-name="leicht &amp; fruchtig" transform="translate(0.029 17.163)" fontSize="20" fontFamily="Gotham" letterSpacing="0.1em"><tspan x="35" y="15">LEICHT &amp; FRUCHTIG</tspan></text>
                                </g>
                                <g id="Component_29_1" data-name="Component 29 – 1" onMouseOut={() => hideDiv("content_gebietswein")} onMouseOver={() => showDiv("content_gebietswein")} transform="translate(295.381 1747)">
                                    <g id="Rectangle_135" data-name="Rectangle 135" fill="#f2efed" stroke="#766260" strokeWidth="1">
                                        <rect width="309" height="49" stroke="none"/>
                                        <rect x="0.5" y="0.5" width="308" height="48" fill="none"/>
                                    </g>
                                    <text id="GEBIETSWEIN" transform="translate(0.029 17.163)" fontSize="20" fontFamily="Gotham" letterSpacing="0.1em"><tspan x="70" y="15">GEBIETSWEIN</tspan></text>
                                </g>
                                <g id="Component_28_1" data-name="Component 28 – 1" onMouseOut={() => hideDiv("content_ortswein")} onMouseOver={() => showDiv("content_ortswein")} transform="translate(295.381 1625)">
                                    <g id="Rectangle_136" data-name="Rectangle 136" fill="#f2efed" stroke="#766260" strokeWidth="1">
                                        <rect width="309" height="49" stroke="none"/>
                                        <rect x="0.5" y="0.5" width="308" height="48" fill="none"/>
                                    </g>
                                    <text id="ORTSWEIN" transform="translate(0.029 17.163)" fontSize="20" fontFamily="Gotham" letterSpacing="0.1em"><tspan x="90" y="15">ORTSWEIN</tspan></text>
                                </g>
                                <g id="component_lagenwein" data-name="Component 27 – 1" onMouseOut={() => hideDiv("content_lagenwein")} onMouseOver={() => showDiv("content_lagenwein")} transform="translate(294.381 1504)">
                                    <g id="Rectangle_137" data-name="Rectangle 137" fill="#f2efed" stroke="#766260" strokeWidth="1">
                                        <rect width="309" height="49" stroke="none"/>
                                        <rect x="0.5" y="0.5" width="308" height="48" fill="none"/>
                                    </g>
                                    <text id="LAGENWEIN" transform="translate(0.029 17.163)" fontSize="20" fontFamily="Gotham" letterSpacing="0.1em"><tspan x="80" y="15">LAGENWEIN</tspan></text>
                                </g>
                            </g>
                        </svg>
                    </div>
                    <div className={`col-6 ${styles.class}`}>
                        <div id="content_initial" className="col-12" style={{alignItems:"center"}}>
                            <p className="phrase brown" style={{textAlign:"center"}}>Wählen Sie eine Klassifikation<br/> Ihrer Wahl aus</p>
                            <svg xmlns="http://www.w3.org/2000/svg" width="394.354" height="55.207" viewBox="0 0 394.354 55.207">
                                <g id="Group_1293" data-name="Group 1293" transform="translate(-1102.646 -1756.646)">
                                    <line id="Line_80" data-name="Line 80" x2="394" transform="translate(1103 1784)" fill="none" stroke="#7c6765" strokeWidth="1"/>
                                    <line id="Line_81" data-name="Line 81" x2="27" y2="27" transform="translate(1103.5 1784.5)" fill="none" stroke="#7c6765" strokeWidth="1"/>
                                    <line id="Line_82" data-name="Line 82" x1="27" y2="27" transform="translate(1103 1757)" fill="none" stroke="#7c6765" strokeWidth="1"/>
                                </g>
                            </svg>
                            <p>Erfahren Sie mehr über Weine und<br/> Ihren einzigartigen Eigenschaften.</p>
                        </div>
                        <div id="content_lagenwein" style={{display:"none"}} className="col-8">
                            <p className="brown information">Holzspur, Gestein & Steinfeld</p>
                            <p>In unseren Riedenweine spiegeln sich Bodenstruktur und kleinklimatische Unterschiede auf engstem Raum wider.<br/><br/>

                                Sie sind ein Abbild der spezifischen Charaktere der Rieden (Lagen) in der Thermenregion und vereinen die Gisperg‘sche Frucht, besondere Finesse mit gut eingebundenem Holz und einer komplexen inneren Struktur. In unseren Großlagen Reserven vereinen sich unsere besten Rieden. </p>
                        </div>
                        <div id="content_ortswein" style={{display:"none"}} className="col-8">
                            <p className="brown information">Teesdorf & Tattendorf Exklusiv</p>
                            <p>Die Ortsweine bilden die typischen Eigenschaften der örtlichen Gegebenheiten ab.<br/><br/>

                                Eleganz und Balance stehen im Vordergrund der in gebrauchten Barriques ausgebauten und aus Teesdorf & Tattendorf stammenden Weine. </p>
                        </div>
                        <div id="content_gebietswein" style={{display:"none"}} className="col-8">
                            <p className="brown information">Thermenregion Klassik</p>
                            <p>Der typische Thermenregion-Wein ist geprägt von der Ebene, von kühlen Nächten und heißen Tagen, von den fast ganzjährigen pannonischen Winden und dem kargen Kalkschotterboden.<br/><br/>

                                Der Ausbau und die Lagerung finden im großen Holzfass und Edelstahltank statt. </p>
                        </div>
                        <div id="content_leichtfruchtig" style={{display:"none"}} className="col-8">
                            <p className="brown information">Klara, Giovanni & Co.</p>
                            <p>Diese leichte Line sorgt für unkomplizierten Trinkspaß.  Die Weißweine sind besonders fruchtige, spritzig und trinkfreudig. Ebenfalls für unkomplizierten Trinkgenuss sorgen unsere leichten Rotweine, die im Sommer leicht gekühlt eine großartige Alternative zu Weißwein sind. </p>
                        </div>
                    </div>
                </div>
            </section>
            <section className="background_light ">
                <span  className="anchor" id="rieden" ></span>
                <div className="horizontal">
                    <div className="col-6 broad left">
                        <h2>Rieden</h2>
                            <p>Als engste Herkunft ist die Riede (Lage) naturgemäß an der Spitze
                                der Klassifikationspyramide unseres Weingutes angesiedelt.<br/><br/>

                                Die Weingärten die eine Riede ergeben sind parzellengenau abgegrenzt. Hier gedeihen ausdrucksstarke Weine mit expressiver Herkunftstypizität und besonderem Reifepotenzial. Sie spiegeln den individuellen Charakter der definierten Einzellage wider, der sich bereits in der Jugend eindrucksvoll zeigt und der mit zunehmender Reife immer deutlicher hervortritt. </p>
                    </div>
                    <div className="col-6 broad" style={{justifyContent:"space-between", marginTop:"40px"}}>
                        <img alt=""  src="/images/rieden.webp" width="610" height="281"/>
                        <p>Unsere Riedenweine transportieren den Reservestil immanent mit. Unsere bedeutsamsten Rieden sind die Ried Gestein in Teesdorf und die Ried Holzspur in Tattendorf. </p>
                    </div>
                </div>
                <Link href="/weinkauf/shop/details/?id=37"><p className="primary button x3">Die Rieden Kollektion</p></Link>
            </section>
            <section className="background_light_texture ">
                <div className="col-12">
                    <img alt=""  src="/images/map.webp" style={{width:"90%"}} width="2000" height="1144"/>
                </div>
            </section>
            <section className="background_light ">
                <span  className="anchor" id="ortschaften" ></span>
                <div className="horizontal">
                    <div className="col-6 left">
                        <h2>Ortschaften</h2>
                        <div className="col-8">
                            <p>Mit der Benennung der Weine nach ihren Herkunftsgemeinden greifen wir eine alte Tradition wieder auf.<br/><br/>

                            Unsere Ortsweine stammen aus unterschiedlichen Weingärten innerhalb der Orts-Appellationen Teesdorf und Tattendorf, welche unterschiedliche Charakteristika aufweisen, die Aromatik und Typizität dieser Weine prägen. </p>
                        </div>
                        <Link href="/herkunft/ortschaften">
                            <p className="button secondary x2">Mehr erfahren</p>
                        </Link>
                    </div>
                    <div className="col-6">
                        <img alt=""  src="/images/villages.png" width="557" height="379"/>
                    </div>
                </div>
            </section>
            <section className="">
                <span  className="anchor" id="gebiet" ></span>
                <div className="col-12">
                    <h2 className="white" style={{textAlign:"center"}}>Gebiet<br/>Thermenregion</h2>
                </div>
                <div className="col-8">
                    <div className="horizontal" style={{marginTop:"10px", marginBottom:"10px"}}>
                        <h3>Sorten</h3>
                        <h3 className="white">Geografische Lage</h3>
                        <h3>Klima</h3>
                        <h3 className="white">Sorten</h3>
                    </div>
                    <div className="horizontal" style={{marginTop:"10px", marginBottom:"10px"}}>
                        <h3>Klima</h3>
                        <h3>Ursprung</h3>
                        <h3>Geologie</h3>
                        <h3 className="white">Geologie</h3>
                    </div>
                    <div className="horizontal" style={{marginTop:"10px", marginBottom:"10px"}}>
                        <h3 className="white">Ursprung</h3>
                        <h3>Geologie</h3>
                        <h3 className="white">klima</h3>
                        <h3>Geografische Lage</h3>
                    </div>
                    <Link href="/herkunft/gebiet">
                            <p className="button secondary x2 dark">Mehr erfahren</p>
                    </Link>
                </div>
            </section>
            <section className="background_light ">
                <span  className="anchor" id="tourismus" ></span>
                <div className="horizontal">
                    <div className="col-6 left">
                        <h2>Tourismus</h2>
                            <div className="horizontal mobile">
                                <p className="brown quote right">&rdquo;</p>
                                <p className="phrase brown left">Auszeit nehmen<br/>und ab zum Wein!<br/><span className="gotham-bold size-16">- Familie Gisperg</span></p>
                            </div>
                        <Link href="/herkunft/tourismus">
                                <p className="button secondary">erkunden</p>
                        </Link>
                    </div>
                    <div className="col-6">
                        <img alt=""  src="/images/tourismus.webp" width="588" height="392"/>
                    </div>
                </div>
            </section>
        </Layout>
    );
}

function showDiv(id){
    let div = document.getElementById(id);
    let initialDiv = document.getElementById("content_initial");
    div.style.display = "block";
    initialDiv.style.display="none";
}

function hideDiv(id){
    let div = document.getElementById(id);
    let initialDiv = document.getElementById("content_initial");
    div.style.display = "none";
    initialDiv.style.display="block";
}